import { useMemo } from 'react';

import { MembershipFragment } from '@occc/graphql';
import { LinkItem } from '@occc-app/design-system';

import { pageTitle } from './copies';

import { routeCreator, displayFullName } from '../utils';

type HasNameAndId = Pick<MembershipFragment, 'firstName' | 'lastName' | 'id'>;

export const useLinks: (member: HasNameAndId | undefined, pointChangeId: string) => LinkItem[] = (
  member,
  pointChangeId,
) => {
  return useMemo(() => {
    if (!member || !pointChangeId) {
      return [];
    }
    return [
      {
        to: routeCreator.base(),
        label: 'Members',
      },
      {
        to: routeCreator.details(member.id),
        label: displayFullName(member),
      },
      {
        key: routeCreator.pointChange(pointChangeId),
        label: pageTitle,
      },
    ];
  }, [member, pointChangeId]);
};
